import React, {Component} from 'react';
import MatchWhenLoggedIn from '../MatchWhenLoggedIn';
import {Route, Redirect, Switch} from 'react-router-dom';
import NewsList from './NewsList'
import NewsForm from './NewsForm'

class NewsContent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (<div>
            <Switch>
                <Route exact path='/app/news' render={() => (
                    <Redirect
                        to='/app/news/list'
                    />
                )} />
                <MatchWhenLoggedIn path='/app/news/list' component={NewsList} />
                <MatchWhenLoggedIn path='/app/news/edit/:id' component={NewsForm} />
                <MatchWhenLoggedIn path='/app/news/new' component={NewsForm} />
            </Switch>
        </div>)
    }
}

export default NewsContent;




/** WEBPACK FOOTER **
 ** ./src/components/news/NewsContent.js
 **/